import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AuditChatMessage } from './audit-chat-api.service';
import dayjs from 'dayjs';

@Component({
  selector: `ct-shared-audit-chat-message-entry`,
  template: `
    <div class="flex flex-col">
      <div class="text text-theme-gray-600 flex text-xs">
        <span>{{ message().sender.name }}</span>
        <span class="ml-auto">{{ date() }}</span>
      </div>
      <div class="whitespace-pre-wrap">
        {{ message().message }}
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditChatMessageEntryComponent {
  readonly message = input.required<AuditChatMessage>();

  readonly date = computed(() => dayjs(this.message().created).format('DD.MM.YYYY HH:mm:ss'));
}
